import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../../config';

@Injectable()
export class VideozapisiService {

  constructor(private _http: Http) { }

  dodajVideo(video: any){
    return this._http.post(AppConfig.apiAdresaMongoVimeo + 'videos/', video)    
    .map(res => res.json()); 
  }

  dohvatiSve(){
    return this._http.get(AppConfig.apiAdresaMongoVimeo + 'videos/?access_token=' + localStorage.getItem('token'))    
    .map(res => res.json()); 
  }

  urediVideo(video:any){
    return this._http.put(AppConfig.apiAdresaMongoVimeo + 'videos/uredi/' + video['id'], video)    
    .map(res => res.json()); 
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/vimeo/videozapisi/videozapisi.service.ts